import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';


const Location = (props) => {
    const { locale, menu, setMenu, theme, setLocation, location, automaticLocation, departments, setCityFocused,
        setDepartmentFocused,
        departmentFocused,
        setMarker,
        selectedGtaCity,
        selectedGtaStreet,
    } = props;
    const [updatedLocation, setUpdatedLocation] = useState({
        city: '',
        address: '',
        numero: '',
        stage: '',
        gate: '',
        building: '',
        code: '',
        observations: '',
        lngLat: { lng: 0, lat: 0 },
    });
    const [communes, setCommunes] = useState([]);
    const [rues, setRues] = useState([]);

    const onChangeLocation = (e) => {
        const { id, value } = e.target;
        setUpdatedLocation((prevState) => ({
            ...prevState,
            [id]: value !== undefined ? value : prevState[id] || '',
        }));
        if (id === 'city') {
            const dataList = _$('communes');
            const options = Array.from(dataList.options).map((option) => option.value);
            if (options.includes(value)) {
                setCityFocused(value);
            }
        }
        if (id === 'address') {
            const validGtaStreet = selectedGtaStreet?.find((street) => street?.name.toUpperCase() === value);
            if (validGtaStreet && !automaticLocation) {
                const newMarker = {
                    lngLat: validGtaStreet.lngLat,
                    title: locales[locale].sga.location,
                    content: `<div>${updatedLocation.housenumber || 0} ${updatedLocation.address.toUpperCase()} ${updatedLocation.city.toUpperCase()}</div>`, // eslint-disable-line
                    icon: '/images/markers/START.png',
                    id: 'NEW_CALL',
                    flyTo: true,
                };
                const newLngLat = { lng: validGtaStreet.lngLat[0], lat: validGtaStreet.lngLat[1] };
                setUpdatedLocation((prevLocation) => ({
                    ...prevLocation,
                    lngLat: newLngLat,
                }));
                setMarker(newMarker);
            }
        }
    };

    useEffect(() => {
        if (location) {
            setUpdatedLocation(location);
        }
    }, [location]);

    useEffect(() => {
        if (automaticLocation && !location) {
            if (!automaticLocation.city || !automaticLocation.street) return;
            setUpdatedLocation({
                city: automaticLocation.city.toUpperCase() || '',
                address: automaticLocation.street.toUpperCase() || '',
                numero: automaticLocation.housenumber || '',
                lngLat: automaticLocation.lngLat,
            });
            const newMarker = {
                lngLat: automaticLocation.lngLat,
                title: locales[locale].sga.location,
                content: `<div>${automaticLocation.housenumber || 0} ${automaticLocation.street.toUpperCase()} ${automaticLocation.city.toUpperCase()}</div>`,
                icon: '/images/markers/START.png',
                id: 'NEW_CALL',
            };
            setMarker(newMarker);
        }
    }, [automaticLocation]);

    useEffect(() => {
        if (departments.length > 0 && location === false) {
            setCommunes([]);
            for (const dept of departments) {
                fetch(`https://api.alertes-speciales.fr/data/communes/${dept}?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
                    .then((response) => response.json())
                    .then((data) => {
                        data.sort((x, y) => {
                            if (x < y) {
                                return -1;
                            }
                            if (x > y) {
                                return 1;
                            }
                            return 0;
                        });
                        setCommunes((prevCommunes) => [...prevCommunes, ...data]);
                    })
                    .catch((error) => console.error('Erreur lors de la récupération des communes:', error));
            }
        }
        if (departments.length === 1) {
            setDepartmentFocused(departments[0]);
        }
    }, [departments, location]);

    useEffect(() => {
        if (communes.length > 0 && _$('communes')) {
            _$('communes').innerHTML = '';
            for (const commune of communes) {
                const option = document.createElement('option');
                option.value = commune.toUpperCase();
                _$('communes').appendChild(option);
            }
        }
    }, [communes]);

    useEffect(() => {
        if (updatedLocation.city && departmentFocused) {
            fetch(`https://api.alertes-speciales.fr/data/rues/${departmentFocused}/${updatedLocation.city.replace(/ /g, '-')}?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
                .then((response) => response.json())
                .then((data) => {
                    data.sort((x, y) => {
                        if (x < y) {
                            return -1;
                        }
                        if (x > y) {
                            return 1;
                        }
                        return 0;
                    });
                    setRues((prevRues) => [...prevRues, ...data]);
                })
                .catch((error) => console.error('Erreur lors de la récupération des rues:', error));
        }
    }, [updatedLocation.city, departmentFocused]);

    useEffect(() => {
        if (rues.length > 0 && _$('rues')) {
            _$('rues').innerHTML = '';
            for (const rue of rues) {
                const option = document.createElement('option');
                option.value = rue.toUpperCase();
                _$('rues').appendChild(option);
            }
        }
    }, [rues]);

    useEffect(() => {
        if (selectedGtaStreet.length > 0 && _$('rues')) {
            _$('rues').innerHTML = '';
            for (const rue of selectedGtaStreet) {
                const option = document.createElement('option');
                option.value = rue.name.toUpperCase();
                _$('rues').appendChild(option);
            }
        }
    }, [selectedGtaStreet]);

    useEffect(() => {
        if (selectedGtaCity.length > 0 && _$('communes')) {
            _$('communes').innerHTML = '';
            for (const commune of selectedGtaCity) {
                const option = document.createElement('option');
                option.value = commune.toUpperCase();
                _$('communes').appendChild(option);
            }
        }
    }, [selectedGtaCity]);

    return (
        !location ? (
            <div className={`col-${menu === 'Location' ? '8' : '4'}`} onClick={() => setMenu('Location')}>
                <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h5 className='alert-heading'>{locales[locale].sga.location}</h5>
                    <div className='form-group'>
                        <label htmlFor='city'>{locales[locale].sga.city}</label>
                        <input
                            type='text'
                            className='form-control'
                            id='city'
                            value={updatedLocation.city}
                            onChange={onChangeLocation}
                            autoComplete="off"
                            list="communes"
                        />
                        <datalist id="communes"></datalist>
                        <label htmlFor='address'>{locales[locale].sga.address}</label>
                        <input
                            type='text'
                            className='form-control'
                            id='address'
                            value={updatedLocation.address}
                            onChange={onChangeLocation}
                            autoComplete="off"
                            list="rues"
                        />
                        <datalist id="rues"></datalist>
                        <div className='row'>
                            <div className='col-3'>
                                <label htmlFor='numero'>{locales[locale].sga.numero}</label>
                                <input type='text' className='form-control' id='numero' value={updatedLocation.numero} onChange={onChangeLocation} />
                            </div>
                            <div className='col-3'>
                                <label htmlFor='stage'>{locales[locale].sga.stage}</label>
                                <input type='text' className='form-control' id='stage' value={updatedLocation.stage} onChange={onChangeLocation} />
                            </div>
                            <div className='col-3'>
                                <label htmlFor='gate'>{locales[locale].sga.gate}</label>
                                <input type='text' className='form-control' id='gate' value={updatedLocation.gate} onChange={onChangeLocation} />
                            </div>
                            <div className='col-3'>
                                <label htmlFor='building'>{locales[locale].sga.building}</label>
                                <input type='text' className='form-control' id='building' value={updatedLocation.building} onChange={onChangeLocation} />
                            </div>
                            <div className='col-3'>
                                <label htmlFor='code'>{locales[locale].sga.code}</label>
                                <input type='text' className='form-control' id='code' value={updatedLocation.code} onChange={onChangeLocation} />
                            </div>
                        </div>

                        <label htmlFor='observations'>{locales[locale].sga.observations}</label>
                        <textarea
                            className='form-control'
                            id='observations'
                            rows='3'
                            value={updatedLocation.observations}
                            onChange={onChangeLocation}
                        ></textarea>
                        <div type='text' className='form-control m-1' id='lngLat' disabled>
                            {Number(updatedLocation.lngLat.lng).toFixed(5)};{Number(updatedLocation.lngLat.lat).toFixed(5)}
                        </div>
                    </div>
                    <div className='form-check text-right'>
                        <button className='btn btn-primary btn-sm m-2 pl-4 pr-4' onClick={() => setLocation(true)}>
                            {locales[locale].sga.validate}
                        </button>
                    </div>
                </div>
            </div>
        ) : (
            <div className={`col-${menu === 'Location' ? '8' : '4'}`} onClick={() => setMenu('Location')}>
                <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h5 className='alert-heading'>{locales[locale].sga.location}</h5>
                    <p>{location.city}</p>
                    <p>{location.address}</p>
                    <div>
                        <span>{location.numero}</span>
                        <span className='ml-2'>{location.stage}</span>
                        <span className='ml-2'>{location.gate}</span>
                        <span className='ml-2'>{location.building}</span>
                        <span className='ml-2'>{location.code}</span>
                    </div>
                    <label htmlFor='observations'>{locales[locale].sga.observations}</label>
                    <textarea className='form-control' id='observations' rows='3' value={location.observations} disabled></textarea>
                    <div className='form-check text-right'>
                        <button className='btn btn-primary btn-sm m-2 pl-4 pr-4' onClick={() => setLocation(false)}>
                            {locales[locale].sga.update}
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default Location;
